export const pillars = ['Incidents', 'Use of Force', 'Logs & Counts', 'Write-Ups', 'Searches', 'Career'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  short: 'Incident Reports & Daily Narratives',
  title: 'Incident Reports & Daily Narratives (The End-of-Shift Pack)',
  desc: '20 prompts for fights, staff assaults, threats, refusals, property damage, medical emergencies, witness statements and a final quality check before you submit.'
}, {
  n: 2,
  emoji: '📕',
  short: 'Use of Force & Emergency Response',
  title: 'Use of Force & Emergency Response (The Critical Incident Pack)',
  desc: '20 prompts for primary and supplemental use-of-force reports, cell extractions, OC spray, restraints, codes, lockdowns, evacuations and after-action reviews.'
}, {
  n: 3,
  emoji: '📓',
  short: 'Shift Logs, Counts & Handovers',
  title: 'Shift Logs, Counts, Posts & Handovers (The Shift Command Pack)',
  desc: '20 prompts for logbook entries, count discrepancies, rounds, key control, intake and release, restrictive housing records and shift handovers.'
}, {
  n: 4,
  emoji: '📗',
  short: 'Discipline, Grievances & Watch',
  title: 'Inmate Documentation: Discipline, Grievances, Classification & Watch (The Inmate Records Pack)',
  desc: '20 prompts for write-ups, hearing statements, grievance responses, request forms, classification notes, observation logs and referrals.'
}, {
  n: 5,
  emoji: '📙',
  short: 'Searches, Contraband & Intel',
  title: 'Searches, Contraband, Security Threat Groups & Intelligence (The Security & Intel Pack)',
  desc: '20 prompts for cell and area searches, contraband seizures, chain of custody, mailroom and visitation reports, STG observations and search operations.'
}, {
  n: 6,
  emoji: '📔',
  short: 'Communication, Career & Admin',
  title: 'Communication, Career & Administration (The Career Pack)',
  desc: '20 prompts for memos, leave and overtime requests, promotion exam study plans, mock boards, FTO reports, policy summaries and resumes.'
}];
export const volumeIncludes = ['Complete copy-and-paste prompts (not descriptions)', 'Fill-in-the-blank [brackets] for your own verified facts', 'A "Use it when" line and a pro tip for every prompt', 'Writing boxes for your facility notes'];
export const bonuses = [{
  n: '01',
  title: 'The Body-Cam & Radio Notes-to-Report Converter™',
  desc: 'Turn voice notes, camera transcripts and radio times into an organized draft without losing a fact.',
  image: 'https://cdn.magicpatterns.com/uploads/7QCipKTUNydCEiPrNfW93e/Guia_Body-Cam_y_Radio.webp'
}, {
  n: '02',
  title: 'The Report Red-Flag Self-Audit Checklist™',
  desc: '25 red flags that get reports sent back, and the AI audit prompts to catch them before you submit.',
  image: 'https://cdn.magicpatterns.com/uploads/8Hh8ugGYLommya1EYni8t7/Guia_Body-Cam_y_Radio_(1).webp'
}, {
  n: '03',
  title: 'The Sergeant’s Roll-Call & Shift-Briefing Generator™',
  desc: 'Prepare a clear, focused shift briefing in minutes from the information you already have.',
  image: 'https://cdn.magicpatterns.com/uploads/1GzMbbeFZvcZddqJhXFEnG/Guia_Body-Cam_y_Radio_(2).webp'
}, {
  n: '04',
  title: 'The 12-Hour Shift Survival Planner™',
  desc: 'Sleep, meal-prep and decompression planners built around nights, rotations and overtime.',
  image: 'https://cdn.magicpatterns.com/uploads/c531WwD52wcRdg1Znhz6Qr/Guia_Body-Cam_y_Radio_(3).webp'
}];
